<template>
  <div>
    <router-link v-if="!isShare"
      :to="{
            name: 'topicColumnDetail',
            params: { discussID: topicItem.discussID }
        }">
      <div id="listHead">
        <div class="listHead">
          <div class="listHead_left">
            <div v-if="topicItem.faceUrl!=='' && topicItem.faceUrl && topicItem.faceUrl.length>0" class="listHead_img"
                 :style="{backgroundImage:`url(${topicItem.faceUrl && topicItem.faceUrl.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com')})`}"></div>
            <div v-if="topicItem.faceUrl===''" class="listHead_img1"></div>
            <div class="listHead_name" >
              <p class="themeColor" v-html="parseSpace(topicItem.nickName || '缺少昵称')"></p>
              <p> {{topicItem.createTime| parseDateTime}}</p>
            </div>
          </div>
          <!--<div class="listHead_right">-->
          <!--<div class="listHead_comment">-->
          <!--<img src="../../images/icon-comment-pre.png">-->
          <!--<span v-text="item.commentCount"></span>-->
          <!--</div>-->
          <!--<div class="listHead_praise">-->
          <!--<img src="../../images/icon-praise-pre.png">-->
          <!--<span v-text="item.praiseCount"></span>-->
          <!--</div>-->
          <!--</div>-->
        </div>
      </div>
    </router-link>

    <div v-else>
      <div id="listHead1">
        <div class="listHead">
          <div class="listHead_left">
            <div v-if="topicItem.faceUrl!=='' && topicItem.faceUrl && topicItem.faceUrl.length>0" class="listHead_img"
                 :style="{backgroundImage:`url(${topicItem.faceUrl && topicItem.faceUrl.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com')})`}"></div>
            <div v-if="topicItem.faceUrl===''" class="listHead_img1"></div>
            <div class="listHead_name">
              <p class="themeColor" v-html="parseSpace(topicItem.nickName || '缺少昵称')"></p>
              <p>{{ topicItem.createTime| parseDateTime }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import utils from '../../tool/utils'
  const _userAgent = window.navigator.userAgent
  const _agent = _userAgent.indexOf('xkyApp') === -1
  const _isMobile = _userAgent.indexOf('Android') > -1 || _userAgent.indexOf('Linux') > -1 || _userAgent.indexOf('iPhone') > -1

  export default {
    created () {
    },
    props: ['topicItem', 'themeColor'],
    data () {
      return {
        isShare: false
      }
    },
    beforeMount () {
      if (_agent && _isMobile) {
        this.isShare = true
      } else {
        this.isShare = false
      }
    },
    // computed: {
    //   capitalize: function () {
    //     // let str = this.item && this.item.createTime && this.item.createTime.slice(5, 16) || ''
    //     // return str
    //     let str = utils.parseDateTime(this.item.createTime)
    //     console.log(str)
    //     return utils.parseDateTime(this.item.createTime)
    //   }
    // },
    filters: {
      parseDateTime: function (t) {
        return utils.parseDateTime(t)
      }
    },
    methods: {
      parseSpace: function (t) {
        return utils.parseSpace(t)
      }
    }
  }
</script>

<style scoped>
  .listHead {
    overflow: hidden;
  }

  .listHead_left,
  .listHead_right {
    overflow: hidden;
    float: left;
    /*width: 50%;*/
    height: 0.9rem;
  }

  .listHead_left div {
    float: left;
  }

  .listHead_right div {
    float: right;
  }

  .listHead_img {
    width: 0.52rem;
    height: 0.52rem;
    border-radius: 50%;
    margin: 0.28rem 0.16rem 0 0.1rem;
    background-size: contain;
    background-position: center;
  }

  .listHead_img1 {
    width: 0.52rem;
    height: 0.52rem;
    border-radius: 50%;
    margin: 0.28rem 0.16rem 0 0.1rem;
    background: url(../../images/icon-head.png) no-repeat;
    background-size: contain;
    background-position: center;
  }

  .listHead_name {
    /*width: 3.5rem;*/
    /*height: 0.52rem;*/
    color: #999999;
    margin-top: 0.13rem;
    /*overflow: hidden;*/
  }

  .listHead_name > p:first-child {
    width: 5rem;
    height: 0.25rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

  }

  .listHead_name p {
    font-size: 0.17rem;
    height: 0.25rem;
    line-height: .25rem;
    margin-top: 0.12rem;
  }

  .listHead_name p:first-child {
    margin-top: 0.12rem;
    color: #13b7f6;
    font-size: 0.23rem;
  }

  .listHead_praise,
  .listHead_comment {
    height: 100%;
    overflow: hidden;
  }

  .listHead_praise {
    margin-right: 0.2rem;
  }

  .listHead_praise span,
  .listHead_comment span {
    font-size: 0.2rem;
    float: right;
    margin: 0.33rem 0.1rem 0 0;
  }

  .listHead_praise img,
  .listHead_comment img {
    width: 0.38rem;
    float: right;
    margin: 0.3rem 0.1rem 0 0.1rem;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// listhead.vue?13a89f24